import { useEffect, useMemo, useState } from "react";
import api from "../lib/api";
import BuddyCard from "../components/BuddyCard";
import { Reveal } from "../components/motion";

const SORTS = [
  ["featured", "Featured"], ["newest", "Newest"], ["popular", "Most Popular"],
  ["price-asc", "Price: Low to High"], ["price-desc", "Price: High to Low"],
];

export default function Shop() {
  const [buddies, setBuddies] = useState([]);
  const [personality, setPersonality] = useState("all");
  const [availability, setAvailability] = useState("all");
  const [sort, setSort] = useState("featured");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/buddies").then((r) => setBuddies(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const personalities = useMemo(() => [...new Set(buddies.map((b) => b.personality))], [buddies]);

  const filtered = useMemo(() => {
    let list = buddies.filter((b) =>
      (personality === "all" || b.personality === personality) &&
      (availability === "all" || b.availability === availability));
    if (sort === "price-asc") list = [...list].sort((a, b) => a.price - b.price);
    if (sort === "price-desc") list = [...list].sort((a, b) => b.price - a.price);
    if (sort === "newest") list = [...list].reverse();
    return list;
  }, [buddies, personality, availability, sort]);

  const selectCls = "h-11 rounded-full border border-blush bg-white px-4 text-sm font-semibold text-navy focus:border-pink focus:outline-none";

  return (
    <div className="bg-cream" data-testid="shop-page">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:py-24">
        <Reveal className="text-center">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-pinkdeep">Shop Bedtime Buddies</p>
          <h1 className="mx-auto mt-4 max-w-2xl font-display text-4xl font-medium text-navy sm:text-5xl">Every Buddy is waiting for their person.</h1>
          <p className="mx-auto mt-4 max-w-lg text-base text-navy/55">Oversized 24" cuddle companions with glowing bellies, stories and soothing sounds. Free shipping over $75.</p>
        </Reveal>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-3" data-testid="shop-filters">
          <select value={personality} onChange={(e) => setPersonality(e.target.value)} aria-label="Filter by personality" data-testid="filter-personality" className={selectCls}>
            <option value="all">All Personalities</option>
            {personalities.map((p) => <option key={p} value={p}>{p}</option>)}
          </select>
          <select value={availability} onChange={(e) => setAvailability(e.target.value)} aria-label="Filter by availability" data-testid="filter-availability" className={selectCls}>
            <option value="all">All Availability</option>
            <option value="in_stock">In Stock</option>
            <option value="coming_soon">Coming Soon</option>
          </select>
          <select value={sort} onChange={(e) => setSort(e.target.value)} aria-label="Sort products" data-testid="sort-select" className={selectCls}>
            {SORTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <span className="text-sm text-navy/40" data-testid="shop-count">{filtered.length} Buddies</span>
        </div>

        {loading ? (
          <div className="mt-16 text-center text-navy/40" data-testid="shop-loading">Waking up the Buddies…</div>
        ) : (
          <div className="mt-12 grid justify-items-center gap-7 sm:grid-cols-2 lg:grid-cols-3" data-testid="shop-grid">
            {filtered.map((b, i) => <BuddyCard key={b.slug} buddy={b} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
